module.exports = __webpack_public_path__ + "media/images/front/icon_05_arrow_y-ff08fd34bf8f923022b9afbee6249264.png";